import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import type { ButtonProps } from '../form';
import { Button } from '../form';

/**
 * Bouton intelligent qui se désactive automatiquement pendant la soumission du formulaire
 * Étend le composant Button de base avec la logique de formulaire
 */
export const SmartButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ type = 'submit', children = 'Continuer', disabled, value, ...props }, ref) => {
    const methods = useFormContext();

    return (
      <Button 
        disabled={methods.formState.isSubmitting || disabled} 
        ref={ref} 
        type={type} 
        {...props}
      >
        {value ?? children}
      </Button>
    );
  }
);

SmartButton.displayName = 'SmartButton';
